import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import DocumentTitle from 'react-document-title'
import qs from 'qs'
import Icon from '../../components/misc/Icons'
import { verifyMobileSignin } from '../../actions/session'
import getErrorMessageForRequest from '../../utils/getErrorMessageForRequest'

class VerifyMobileSigninContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      status: 'loading', // 'loading' | 'success' | 'brokenLink' | 'error'
      errorMessage: '',
    }
  }

  componentDidMount() {
    const { location, verifyMobileSignin } = this.props
    const params = qs.parse(location.search.slice(1))
    const { authFlowEvent, code } = params

    if (!authFlowEvent || !code) {
      this.setState({ status: 'brokenLink' })
      return
    }

    verifyMobileSignin(authFlowEvent, code)
      .then(() => {
        this.setState({ status: 'success' })
      })
      .catch((err) => {
        const message = getErrorMessageForRequest({
          requestName: 'verifyMobileSignin',
          response: err.response,
        })
        this.setState({ status: 'error', errorMessage: message })
      })
  }

  render() {
    const { status, errorMessage } = this.state

    return (
      <DocumentTitle title='Plickers - Verify Mobile Sign-In'>
        <div className='verifyMobileSigninPage'>
          <div className='verifyMobileSigninPage-card marketing'>
            <div className='verifyMobileSigninPage-logo'>
              <Icon name='logo-full' />
            </div>
            <div className='verifyMobileSigninPage-divider' />

            {status === 'loading' && (
              <div className='verifyMobileSigninPage-title verifyMobileSigninPage-title--loading'>
                Verifying...
              </div>
            )}

            {status === 'success' && (
              <React.Fragment>
                <div className='verifyMobileSigninPage-checkIcon'>
                  <Icon name='check-circle' />
                </div>
                <div className='verifyMobileSigninPage-title'>
                  Identity Verified
                </div>
                <div className='verifyMobileSigninPage-message'>
                  Thanks for verifying your identity. Please try signing in again on the mobile app.
                </div>
              </React.Fragment>
            )}

            {(status === 'brokenLink' || status === 'error') && (
              <React.Fragment>
                <div className='verifyMobileSigninPage-title verifyMobileSigninPage-title--error'>
                  {status === 'brokenLink' ? 'Invalid Link' : 'Verification Failed'}
                </div>
                <div className='verifyMobileSigninPage-message'>
                  {status === 'brokenLink' ?
                    'This link appears to be broken or incomplete. Please make sure you have the correct link.' :
                    errorMessage}
                </div>
              </React.Fragment>
            )}
          </div>
        </div>
      </DocumentTitle>
    )
  }
}

export default withRouter(connect(
  () => ({}),
  { verifyMobileSignin },
)(VerifyMobileSigninContainer))
